// extracted by mini-css-extract-plugin
export var controls = "print-module__controls___E6tGU";